
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CustomisationBanner',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getGbFeatureValue: 'growthbook/getGbFeatureValue',
    }),

    customisationModalEnabled () {
      return this.getGbFeatureValue('comfort-suite:customisation-modal', false)
    },
  },
  methods: {
    ...mapActions('ui', [
      'showCustomisationPopup',
    ]),
    showCustomisation () {
      const payload = { currentProduct: this.product }
      this.showCustomisationPopup(payload)
    },
  },
}
